const ActionTypes = {
  SET_PAGE: 'SET_PAGE',
  UPDATE_DEVICES_PAGE_ACTIVE_TAB: 'UPDATE_DEVICES_PAGE_ACTIVE_TAB',
  UPDATE_STATUS: 'UPDATE_STATUS',
  UPDATE_STATUS_BUNDLE: 'UPDATE_STATUS_BUNDLE',
  UPDATE_DEVICES: 'UPDATE_DEVICES',
  UPDATE_DEVICES_IDS: 'UPDATE_DEVICES_IDS',
  // SET_DEVICE_SETS_DEVICESTABLE: 'SET_DEVICE_SETS_DEVICESTABLE',
  UPDATE_DEVICE_SETS_DEVICETABLE_DATA_PIVOT_TAB: 'UPDATE_DEVICE_SETS_DEVICETABLE_DATA_PIVOT_TAB',
  UPDATE_DEVICE_SETS_DEVICETABLE_DATA_ECHO_TAB: 'UPDATE_DEVICE_SETS_DEVICETABLE_DATA_ECHO_TAB',
  UPDATE_DEVICE_SETS_DEVICETABLE_DATA_ALL_TAB: 'UPDATE_DEVICE_SETS_DEVICETABLE_DATA_ALL_TAB',

  UPDATE_DEVICE_SETS_DEVICETABLE_SORT_PIVOT_TAB: 'UPDATE_DEVICE_SETS_DEVICETABLE_SORT_PIVOT_TAB',
  UPDATE_DEVICE_SETS_DEVICETABLE_SORT_ECHO_TAB: 'UPDATE_DEVICE_SETS_DEVICETABLE_SORT_ECHO_TAB',
  UPDATE_DEVICE_SETS_DEVICETABLE_SORT_ALL_TAB: 'UPDATE_DEVICE_SETS_DEVICETABLE_SORT_ALL_TAB',
  // SET_DEVICE_SETS_PARAMETERSTABLE: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA',

  UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_PIVOT_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_PIVOT_TAB',
  UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_ECHO_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_ECHO_TAB',
  UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_ALL_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_DATA_ALL_TAB',

  UPDATE_DEVICE_SETS_PARAMETERSGRAPH_PIVOT_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSGRAPH_PIVOT_TAB',
  UPDATE_DEVICE_SETS_PARAMETERSGRAPH_ECHO_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSGRAPH_ECHO_TAB',
  UPDATE_DEVICE_SETS_PARAMETERSGRAPH_ALL_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSGRAPH_ALL_TAB',

  // SET_DEVICE_SETS_DEVICEMAP: 'SET_DEVICE_SETS_DEVICEMAP',
  UPDATE_DEVICE_SETS_DEVICEMAP_DATA_PIVOT_TAB: 'UPDATE_DEVICE_SETS_DEVICEMAP_DATA_PIVOT_TAB',
  UPDATE_DEVICE_SETS_DEVICEMAP_DATA_ECHO_TAB: 'UPDATE_DEVICE_SETS_DEVICEMAP_DATA_ECHO_TAB',
  UPDATE_DEVICE_SETS_DEVICEMAP_DATA_ALL_TAB: 'UPDATE_DEVICE_SETS_DEVICEMAP_DATA_ALL_TAB',

  UPDATE_DEVICE_SETS_INITIAL_REQUEST_PIVOT_TAB: 'UPDATE_DEVICE_SETS_INITIAL_REQUEST_PIVOT_TAB',
  UPDATE_DEVICE_SETS_INITIAL_REQUEST_ECHO_TAB: 'UPDATE_DEVICE_SETS_INITIAL_REQUEST_ECHO_TAB',
  UPDATE_DEVICE_SETS_INITIAL_REQUEST_ALL_TAB: 'UPDATE_DEVICE_SETS_INITIAL_REQUEST_ALL_TAB',

  UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_PIVOT_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_PIVOT_TAB',
  UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_ECHO_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_ECHO_TAB',
  UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_ALL_TAB: 'UPDATE_DEVICE_SETS_PARAMETERSTABLE_SORT_ALL_TAB',

  UPDATE_DEVICES_DICTIONARY: 'UPDATE_DEVICES_DICTIONARY',
  UPDATE_BUNDLES_DICTIONARY: 'UPDATE_BUNDLES_DICTIONARY',
  UPDATE_BUNDLES: 'UPDATE_BUNDLES',
  UPDATE_FILTERED_DEVICES: 'UPDATE_FILTERED_DEVICES',
  UPDATE_FILTERED_DEVICES_WITH_LIST: 'UPDATE_FILTERED_DEVICES_WITH_LIST',
  UPDATE_LOCAL_FILTERED_DEVICES: 'UPDATE_LOCAL_FILTERED_DEVICES',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_SOFTWARE_UPDATE_STATUS: 'SET_SOFTWARE_UPDATE_STATUS',
  SET_SOFTWARE_UPDATE_STATUS_URL: 'UPDATE_SOFTWARE_UPDATE_STATUS_URL',
  UPDATE_RASTER_PROGRESS: 'UPDATE_RASTER_PROGRESS',
  CLEAR_RASTER_PROGRESS: 'CLEAR_RASTER_PROGRESS',
  UI_SET_DROP_MODAL_OPEN: 'UI_SET_DROP_MODAL_OPEN',
  UI_SET_SRT_LASTSCROLL: 'UI_SET_SRT_LASTSCROLL',
  // UI_SET_TOAST_NOTIFICATION_OPEN: 'UI_SET_TOAST_NOTIFICATION_OPEN',
  //UI_SET_DEVICE_NAME_MODE: "UI_SET_DEVICE_NAME_MODE",

  UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_PIVOT_TAB: 'UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_PIVOT_TAB',
  UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_ECHO_TAB: 'UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_ECHO_TAB',
  UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_ALL_TAB: 'UI_DEVICESPAGE_MAPLISTVIEW_SWITCH_STATUS_ALL_TAB',

  UI_DEVICESPAGE_SHOW_SELECT_LIST_NOTIFICATION: 'UI_DEVICESPAGE_SHOW_SELECT_LIST_NOTIFICATION',
  UI_DEVICESPAGE_SORT_ALARMS: 'UI_DEVICESPAGE_SORT_ALARMS',
  UI_DEVICESPAGE_SET_MAP_SELECT: 'UI_DEVICESPAGE_SET_MAP_SELECT',
  UI_DEVICESPAGE_MAPLISTVIEW_MAP_VIEWPORT: 'UI_DEVICESPAGE_MAPLISTVIEW_MAP_VIEWPORT',
  UI_DEVICESPAGE_MAP_LAST_SELECTION: 'UI_DEVICESPAGE_MAP_LAST_SELECTION',
  UI_DEVICESPAGE_MAP_DRAWINGS: 'UI_DEVICESPAGE_MAP_DRAWINGS',
  UI_DEVICESPAGE_SELECT_DEVICE_ID: 'UI_DEVICESPAGE_SELECT_DEVICE_ID',
  UI_DEVICESPAGE_EXPANDED_BUNDLE_ID: 'UI_DEVICESPAGE_EXPANDED_BUNDLE_ID',
  UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_PIVOT_TAB: 'UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_PIVOT_TAB',
  UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_ECHO_TAB: 'UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_ECHO_TAB',
  UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_ALL_TAB: 'UI_DEVICESPAGE_UPDATE_SELECTED_DEVICES_LIST_ALL_TAB',

  UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_PIVOT_TAB: 'UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_PIVOT_TAB',
  UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_ECHO_TAB: 'UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_ECHO_TAB',
  UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_ALL_TAB: 'UI_DEVICESPAGE_CLEAR_DEVICE_INDEX_LIST_ALL_TAB',

  UI_DEVICESPAGE_SET_BULK_ACTION_MODAL_OPEN: 'UI_DEVICESPAGE_SET_BULK_ACTION_MODAL_OPEN',
  UI_DEVICESPAGE_SET_BULK_VIEW_MODAL_OPEN: 'UI_DEVICESPAGE_SET_BULK_VIEW_MODAL_OPEN',
  UI_DEVICESPAGE_SET_BULK_CREATE_LIST_MODAL_OPEN: 'UI_DEVICESPAGE_SET_BULK_CREATE_LIST_MODAL_OPEN',
  UI_DEVICESPAGE_SET_BULK_MANAGE_LISTS_MODAL_OPEN: 'UI_DEVICESPAGE_SET_BULK_MANAGE_LISTS_MODAL_OPEN',
  UI_DEVICESPAGE_SET_MANAGE_COLUMNS_MODAL_OPEN: 'UI_DEVICESPAGE_SET_MANAGE_COLUMNS_MODAL_OPEN',
  UI_DEVICESPAGE_SET_VIEW_DEVICES_LIST_MODAL_OPEN: 'UI_DEVICESPAGE_SET_VIEW_DEVICES_LIST_MODAL_OPEN',
  UI_DEVICESPAGE_SET_SW_UPDATE_STATUS_MODAL_OPEN: 'UI_DEVICESPAGE_SET_SW_UPDATE_STATUS_MODAL_OPEN',
  UI_DEVICESPAGE_UPDATE_SELECTED_DEVICE_GROUP_NAME: 'UI_DEVICESPAGE_UPDATE_SELECTED_DEVICE_GROUP_NAME',
  UI_DEVICESPAGE_SET_IS_DEFAULT_DEVICE_GROUP_INITIALIZED: 'UI_DEVICESPAGE_SET_IS_DEFAULT_DEVICE_GROUP_INITIALIZED',

  UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_PIVOT_TAB: 'UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_PIVOT_TAB',
  UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_ECHO_TAB: 'UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_ECHO_TAB',
  UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_ALL_TAB: 'UI_DEVICESPAGE_SET_SELECTED_PARAMETERS_ALL_TAB',

  UI_DEVICESPAGE_SET_BULK_SELECT_ACTIVE: 'UI_DEVICESPAGE_SET_BULK_SELECT_ACTIVE',

  UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_PIVOT_TAB: 'UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_PIVOT_TAB',
  UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_ECHO_TAB: 'UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_ECHO_TAB',
  UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_ALL_TAB: 'UI_DEVICESPAGE_SET_DEVICE_DISPLAY_MODE_ALL_TAB',

  UI_DEVICESPAGE_UPDATE_ALL_USER_DEVICE_GROUPS: 'UI_DEVICESPAGE_UPDATE_ALL_USER_DEVICE_GROUPS',
  UI_DEVICESPAGE_EDIT_SINGLE_DEVICE_GROUP: 'UI_DEVICESPAGE_EDIT_SINGLE_DEVICE_GROUP',

  UI_DEVICESPAGE_UPDATE_ALL_USER_DEVICE_POLYGONS: 'UI_DEVICESPAGE_UPDATE_ALL_USER_DEVICE_POLYGONS',
  UI_DEVICESPAGE_DELETE_USER_DEVICE_POLYGON: 'UI_DEVICESPAGE_DELETE_USER_DEVICE_POLYGON',

  HANDLE_MAPLISTVIEW_SEARCH_QUERY: 'HANDLE_MAPLISTVIEW_SEARCH_QUERY',

  DEVICE_PARAMETER_SCHEMA: 'DEVICE_PARAMETER_SCHEMA',

  UI_SINGLE_DEVICE_PAGE_SELECTED_DEVICE: 'UI_SINGLE_DEVICE_PAGE_SELECTED_DEVICE',
  UI_SINGLE_DEVICE_PAGE_PATCH_VALUES: 'UI_SINGLE_DEVICE_PAGE_PATCH_VALUES',
  UI_SINGLE_DEVICE_PAGE_CLEAR_PATCH_VALUES: 'UI_SINGLE_DEVICE_PAGE_CLEAR_PATCH_VALUES',
  UI_SINGLE_DEVICE_PAGE_SET_SW_VERSION_MODAL_OPEN: 'UI_SINGLE_DEVICE_PAGE_SET_SW_VERSION_MODAL_OPEN',
  UI_SINGLE_DEVICE_PAGE_SET_SEARCH_BAR_INDEX: 'UI_SINGLE_DEVICE_PAGE_SET_SEARCH_BAR_INDEX',
  UI_SINGLE_DEVICE_PAGE_CHART_SELECTION_SAVE: 'UI_SINGLE_DEVICE_PAGE_CHART_SELECTION_SAVE',
  UI_SINGLE_DEVICE_PAGE_CHART_SELECTIONS_SAVE: 'UI_SINGLE_DEVICE_PAGE_CHART_SELECTIONS_SAVE',
  UI_SINGLE_DEVICE_PAGE_CONFIG_CHART_MODAL_OPEN: 'UI_SINGLE_DEVICE_PAGE_CONFIG_CHART_MODAL_OPEN',
  UI_SINGLE_DEVICE_PAGE_SELECTED_EVENTLOG_INDEX: 'UI_SINGLE_DEVICE_PAGE_SELECTED_EVENTLOG_INDEX',
  UI_SINGLE_DEVICE_PAGE_DISPLAY_LIVE_LOGS: 'UI_SINGLE_DEVICE_PAGE_DISPLAY_LIVE_LOGS',
  UI_SINGLE_DEVICE_PAGE_LOCAL_LOG_LIST: 'UI_SINGLE_DEVICE_PAGE_LOCAL_LOG_LIST',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORYVIEW_SWITCH_STATE: 'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORYVIEW_SWITCH_STATE',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_KPISCHECKBOXITEMS: 'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_KPISCHECKBOXITEMS',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_PARAMCHECKBOXITEMS: 'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_PARAMCHECKBOXITEMS',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_LOCALCOUNTERSDATA: 'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_LOCALCOUNTERSDATA',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SELECTEDCOUNTERS: 'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SELECTEDCOUNTERS',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SAVEDDATACONFIGS: 'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SAVEDDATACONFIGS',
  UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SAVED_CHART_DATA_CONFIGS:
    'UI_SINGLE_DEVICE_PAGE_CONFIGHISTORY_SAVED_CHART_DATA_CONFIGS',
  UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTER_ID: 'UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTER_ID',
  UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_DEVICE_HEATMAP_ROW_IDX:
    'UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_DEVICE_HEATMAP_ROW_IDX',
  UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTER_RECORD: 'UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTER_RECORD',
  UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_BEAMRANK_IDX: 'UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_BEAMRANK_IDX',
  UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTERS_DICTIONARY: 'UI_SINGLE_DEVICE_PAGE_UPDATE_SELECTED_RASTERS_DICTIONARY',
  UI_SINGLE_DEVICE_PAGE_HEATMAP_LIBRARY_TABLE_SET_SELECT_ALL:
    'UI_SINGLE_DEVICE_PAGE_HEATMAP_LIBRARY_TABLE_SET_SELECT_ALL',

  SET_SCROLL_REACT_TABLE_VISIBILITY: 'SET_SCROLL_REACT_TABLE_VISIBILITY',
  SET_JUAN_STYLE: 'SET_JUAN_STYLE',
  SET_CONSOLE_PAGE_SIZE: 'SET_CONSOLE_PAGE_SIZE',
  SET_MAP_SIZE: 'SET_MAP_SIZE',
  SET_CONSOLE_PAGE_CLASS: 'SET_CONSOLE_PAGE_CLASS',
  SET_BLOCKED_LAYER_SHOW: 'SET_BLOCKED_LAYER_SHOW',
  SET_ACTIVE_POLYGON: 'SET_ACTIVE_POLYGON',
  SET_DEFAULT_ACTIVE_POLYGON: 'SET_DEFAULT_ACTIVE_POLYGON',

  SAVE_DEVICE_TO_HISTORY: 'SAVE_DEVICE_TO_HISTORY',

  SET_PROVISIONED_FILTER_RANGE: 'SET_PROVISIONED_FILTER_RANGE',
  BUILD_FILTER_BODY: 'BUILD_FILTER_BODY',
  REMOVE_FROM_FILTER_BODY: 'REMOVE_FROM_FILTER_BODY',
  UPDATE_AVAILABLE_SW_VERSIONS: 'UPDATE_AVAILABLE_SW_VERSIONS',
  UPDATE_SUPPORTED_COMMISSIONING_WEBSITE_VERSIONS: 'UPDATE_SUPPORTED_COMMISSIONING_WEBSITE_VERSIONS',

  GET_DEFAULT_SW_VERSION: 'GET_DEFAULT_SW_VERSION',
  UPDATE_DEFAULT_SW_VERSION: 'UPDATE_DEFAULT_SW_VERSION',

  GET_ALL_BEAM_TABLES: 'GET_ALL_BEAM_TABLES',

  GET_ACTIONS_LIST: 'GET_ACTIONS_LIST',
  SET_ACTIONS_LIST: 'SET_ACTIONS_LIST',
  UPDATE_ACTIONS_LIST: 'UPDATE_ACTIONS_LIST',
  REMOVE_ACTION_FROM_LIST: 'REMOVE_ACTION_FROM_LIST',
  CLEAR_ACTIONS_LIST: 'CLEAR_ACTIONS_LIST',
  UPDATE_ACTIONS_LIST_FOR_COMMISSION: 'UPDATE_ACTIONS_LIST_FOR_COMMISSION',

  SET_FILTER_LIST_PIVOT_TAB: 'SET_FILTER_LIST_PIVOT_TAB',
  SET_FILTER_LIST_ECHO_TAB: 'SET_FILTER_LIST_ECHO_TAB',
  SET_FILTER_LIST_ALL_TAB: 'SET_FILTER_LIST_ALL_TAB',

  SET_LOCAL_NAME_FILTER: 'SET_LOCAL_NAME_FILTER',

  SET_USER_ROLES: 'SET_USER_ROLES',
  SET_USER_PERMISSIONS: 'SET_USER_PERMISSIONS',

  STORE_ALL_DEVICE_ALARMS: 'STORE_ALL_DEVICE_ALARMS',
  UPDATE_LINKED_DEVICES: 'UPDATE_LINKED_DEVICES',

  UPDATE_SELECTED_DEVICES_DATA_PIVOT_TAB: 'UPDATE_SELECTED_DEVICES_DATA_PIVOT_TAB',
  UPDATE_SELECTED_DEVICES_DATA_ECHO_TAB: 'UPDATE_SELECTED_DEVICES_DATA_ECHO_TAB',
  UPDATE_SELECTED_DEVICES_DATA_ALL_TAB: 'UPDATE_SELECTED_DEVICES_DATA_ALL_TAB',

  REMOVE_SELECTED_DEVICE_DATA_PIVOT_TAB: 'REMOVE_SELECTED_DEVICE_DATA_PIVOT_TAB',
  REMOVE_SELECTED_DEVICE_DATA_ECHO_TAB: 'REMOVE_SELECTED_DEVICE_DATA_ECHO_TAB',
  REMOVE_SELECTED_DEVICE_DATA_ALL_TAB: 'REMOVE_SELECTED_DEVICE_DATA_ALL_TAB',

  CLEAR_SELECTED_DEVICES_DATA_PIVOT_TAB: 'CLEAR_SELECTED_DEVICES_DATA_PIVOT_TAB',
  CLEAR_SELECTED_DEVICES_DATA_ECHO_TAB: 'CLEAR_SELECTED_DEVICES_DATA_ECHO_TAB',
  CLEAR_SELECTED_DEVICES_DATA_ALL_TAB: 'CLEAR_SELECTED_DEVICES_DATA_ALL_TAB',

  STORE_HISTORICAL_EVENTLOGS: 'STORE_HISTORICAL_EVENTLOGS',
  STORE_LIVE_EVENTLOGS: 'STORE_LIVE_EVENTLOGS',

  ADD_TOAST_NOTIFICATION: 'ADD_TOAST_NOTIFICATION',
  DELETE_TOAST_NOTIFICATION: 'DELETE_TOAST_NOTIFICATION',
  CLEAR_TOAST_NOTIFICATIONS: 'CLEAR_TOAST_NOTIFICATIONS',

  SET_STATUS_NOTIFICATION: 'SET_STATUS_NOTIFICATION',
  UPDATE_STATUS_NOTIFICATION: 'UPDATE_STATUS_NOTIFICATION',
  DELETE_STATUS_NOTIFICATION: 'DELETE_STATUS_NOTIFICATION',

  UI_USERS_MANAGEMENT_PAGE_USERS: 'UI_USERS_MANAGEMENT_PAGE_USERS',
  UI_USERS_MANAGEMENT_PAGE_ROLE_USERS: 'UI_USERS_MANAGEMENT_PAGE_ROLE_USERS',
  UI_USERS_MANAGEMENT_PAGE_SEARCH_STRING: 'UI_USERS_MANAGEMENT_PAGE_SEARCH_STRING',
  UI_USERS_MANAGEMENT_PAGE_SELECTED_USER_ID: 'UI_USERS_MANAGEMENT_PAGE_SELECTED_USER_ID',
  UI_USERS_MANAGEMENT_PAGE_UPDATE_SELECTED_USERS_LIST: 'UI_USERS_MANAGEMENT_PAGE_UPDATE_SELECTED_USERS_LIST',
  UI_USERS_MANAGEMENT_PAGE_UPDATE_SELECTED_USERS_DATA: 'UI_USERS_MANAGEMENT_PAGE_UPDATE_SELECTED_USERS_DATA',
  UI_USERS_MANAGEMENT_PAGE_REMOVE_SELECTED_USER_DATA: 'UI_USERS_MANAGEMENT_PAGE_REMOVE_SELECTED_USER_DATA',
  UI_USERS_MANAGEMENT_PAGE_CLEAR_SELECTED_USERS_DATA: 'UI_USERS_MANAGEMENT_PAGE_CLEAR_SELECTED_USERS_DATA',
  UI_USERS_MANAGEMENT_PAGE_CLEAR_SELECTED_USERS_LIST: 'UI_USERS_MANAGEMENT_PAGE_CLEAR_SELECTED_USERS_LIST',
  UI_USERS_MANAGEMENT_PAGE_SET_SELECT_MODE: 'UI_USERS_MANAGEMENT_PAGE_SET_SELECT_MODE',
  UI_USERS_MANAGEMENT_PAGE_ROLE_LIST: 'UI_USERS_MANAGEMENT_PAGE_ROLE_LIST',
  UI_USER_PREFERENCE_MANAGE_MODAL_IS_OPEN: 'UI_USER_PREFERENCE_MANAGE_MODAL_IS_OPEN',
  UI_USER_PREFERENCE_CREATE_MODAL_IS_OPEN: 'UI_USER_PREFERENCE_CREATE_MODAL_IS_OPEN',
  UI_USER_PREFERENCE_ACTIVE_FILTER_SET: 'UI_USER_PREFERENCE_ACTIVE_FILTER_SET',
  UI_CREATE_SITE_MODAL_OPEN: 'UI_CREATE_SITE_MODAL_OPEN',

  UPDATE_HEATMAP: 'UPDATE_HEATMAP',
  SAVE_COMMISSION_AZEL: 'SAVE_COMMISSION_AZEL',
  UPDATE_SNMP: 'UPDATE_SNMP',
  REMOVE_REMOTE: 'REMOVE_REMOTE',

  UPDATE_FEATURE_TOGGLE: 'UPDATE_FEATURE_TOGGLE',
  UPDATE_AUTO_UPDATE_SCHEDULE: 'UPDATE_AUTO_UPDATE_SCHEDULE',
  UPDATE_PRODUCT_TYPES_LIST: 'UPDATE_PRODUCT_TYPES_LIST',
  UPDATE_RASTER_RECORD: 'UPDATE_RASTER_RECORD',
  UPDATE_DEVICE_HEATMAP_HISTORY: 'UPDATE_DEVICE_HEATMAP_HISTORY',

  UPDATE_FACTORY_LIST: 'UPDATE_FACTORY_LIST',
  UPDATE_PROTECTED_LIST: 'UPDATE_PROTECTED_LIST',
  UPDATE_DEVICE_HEATMAP_HISTORY_DICTIONARY: 'UPDATE_DEVICE_HEATMAP_HISTORY_DICTIONARY',

  SET_LAST_SCROLL: 'SET_LAST_SCROLL',
  UI_SET_DEVICETABLE_WIDTH: 'UI_SET_DEVICETABLE_WIDTH',

  UPDATE_ACTIONS_LIST_FOR_TWO_HOP: 'UPDATE_ACTIONS_LIST_FOR_TWO_HOP',
  UPDATE_ACTIONS_PAGE_TWO_HOP_STATUS_INSTANCE_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_STATUS_INSTANCE_DICTIONARY',
  UPDATE_ACTIONS_PAGE_TWO_HOP_PROGRESS_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_PROGRESS_DICTIONARY',
  UPDATE_ACTIONS_PAGE_TWO_HOP_SELECTED_RASTERS_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_SELECTED_RASTERS_DICTIONARY',
  UPDATE_ACTIONS_PAGE_TWO_HOP_RASTER_ID_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_RASTER_ID_DICTIONARY',
  UPDATE_ACTIONS_PAGE_TWO_HOP_SCORE_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_SCORE_DICTIONARY',
  UPDATE_ACTIONS_PAGE_TWO_HOP_REC_BEAM_INFO_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_REC_BEAM_INFO_DICTIONARY',
  UPDATE_ACTIONS_PAGE_TWO_HOP_CANCEL_STATUS_DICTIONARY: 'UPDATE_ACTIONS_PAGE_TWO_HOP_CANCEL_STATUS_DICTIONARY',

  UI_PIVOT_OVERVIEW_PAGE_UPDATE_SELECTED_DEVICES: 'UI_PIVOT_OVERVIEW_PAGE_UPDATE_SELECTED_DEVICES',
  UI_PIVOT_OVERVIEW_PAGE_UPDATE_SINGLE_SELECTED_DEVICE: 'UI_PIVOT_OVERVIEW_PAGE_UPDATE_SINGLE_SELECTED_DEVICE',
  UI_PIVOT_OVERVIEW_PAGE_UPDATE_ACTIVE_TAB: 'UI_PIVOT_OVERVIEW_PAGE_UPDATE_ACTIVE_TAB',
  UI_PIVOT_OVERVIEW_PAGE_UPDATE_RF_CONFIG_ACTION_STATUS: 'UI_PIVOT_OVERVIEW_PAGE_UPDATE_RF_CONFIG_ACTION_STATUS',

  UI_ECHO_OVERVIEW_PAGE_UPDATE_SELECTED_DEVICE: 'UI_ECHO_OVERVIEW_PAGE_UPDATE_SELECTED_DEVICE',

  UI_CHART_EXPLORER_PAGE_UPDATE_SELECTED_DEVICE_ID: 'UI_CHART_EXPLORER_PAGE_UPDATE_SELECTED_DEVICE_ID',
  UI_CHART_SET_SELECT: 'UI_CHART_SET_SELECT',
  UI_CHART_SET_UPDATE: 'UI_CHART_SET_UPDATE',
  GET_RASTER_SETTINGS: 'GET_RASTER_SETTINGS'
};

export default ActionTypes;
